import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import successImage from '../../assets/img/card-request-success.png';
import simpleLineIconsCheck from '../../assets/img/simple-line-icons_check.png';

const SuccessRequest = () => {
  const history = useHistory();
  return (
    <Row className="justify-content-center mt-5">
      <Col md="8" className="text-center">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={successImage}
            alt="Solicitud exitosa"
            className="img-fluid mb-4"
            style={{ maxWidth: '300px' }}
          />
          <img
            src={simpleLineIconsCheck}
            alt="Check exitoso"
            className="img-fluid mb-4"
            style={{ maxWidth: '50px' }}
          />
        </div>
        <h2 style={{ fontWeight: 'normal' }} className="mb-4">
          Solicitud enviada correctamente
        </h2>
        <p className="mb-4">Gracias por completar tus datos.</p>
        <p
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            textAlign: 'justify',
            display: '-webkit-box',
            lineClamp: 3,
            overflow: 'hidden',
          }}
          className="mb-4"
        >
          Una vez aprobada tu solicitud, recibirás un correo con los pasos para
          programar la jura presencial y completar el proceso de matriculación.
        </p>
        <div
          style={{ marginTop: '3rem', marginBottom: '2rem' }}
          className="d-flex justify-content-center"
        >
          <Button
            type="button"
            className="btn-custom"
            onClick={() => history.push('/inicio')}
          >
            Ver el estado de mi solicitud
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default SuccessRequest;
